import Room from './Room';
import VisitList from '../patient/VisitList';
import RoomManageDetails from './RoomManagementDetails';

const rcomponents = {
    Room,
    VisitList,
    RoomManageDetails,
}

export default rcomponents;
